// Init Swiper
// uses: https://github.com/nolimits4web/swiper

(function (window) {
  'use strict';

  const carouselContainerSelector = '.swiperCarouselContainer';
  const carouselThumbContainerSelector = '.swiperCarouselThumbs';
  const carouselNavNextSelector = '.swiper-button-custom-next';
  const carouselNavPrevSelector = '.swiper-button-custom-prev';
  const carouselSpace = 0;
  const carouselSlidesPerView = 'auto';
  const carouselLoop = false;
  const carouselRewind = true;

  function initSwiper() {
    // Get all the sliders on the page
    var $sliderElements = document.querySelectorAll(carouselContainerSelector+'[data-id]');

    if ($sliderElements.length) {
      $sliderElements.forEach(function ($sliderElement) {
        const sliderId = $sliderElement.dataset.id;

        // Find related thumbs container
        const $thumbsContainerElement = document.querySelector(`${carouselThumbContainerSelector}[data-id="${sliderId}"]`);

        // Find navigation buttons
        const $nextEl = document.querySelector(`${carouselNavNextSelector}[data-id="${sliderId}"]`);
        const $prevEl = document.querySelector(`${carouselNavPrevSelector}[data-id="${sliderId}"]`);

        let thumbsSwiper = null;
        if ($thumbsContainerElement) {
          thumbsSwiper = new Swiper($thumbsContainerElement, {
            spaceBetween: carouselSpace,
            slidesPerView: carouselSlidesPerView,
          });
        }

        new Swiper($sliderElement, {
          loop: carouselLoop,
          rewind: carouselRewind,
          thumbs: thumbsSwiper
            ? { swiper: thumbsSwiper }
            : {},
          navigation: {
            nextEl: $nextEl,
            prevEl: $prevEl,
          },
        });
      });
    }
  }

  initSwiper();
})(this);
